import { ACCOUNT_ID } from "../App";

export const fetcher = (uri, options = {}) => {
    const headers = {
        'Authorization': localStorage.getItem('authorizationHeader'),
        'Content-Type': 'application/json',
        'X-Homestead-Account': ACCOUNT_ID,
        ...options.headers,
    }

    if ('headers' in options && 'Content-Type' in options.headers && options.headers['Content-Type'] === null) {
        console.log('hello')

        delete headers['Content-Type'];
    }


    return fetch(uri, {
        ...options,
        headers: headers
    }).then(r => {
        if (r.status === 200) {
            return r.json();
        }

        return;
    });
};